import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-banner`,
};

const strings = {
    TYPE: ['info', 'success', 'danger', 'warning'],
};

export {
    cssClasses,
    strings
};